var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665_13996)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    rx: 66,
    fill: "#00B96B",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9993 124.333C98.216 124.333 124.333 98.2164 124.333 65.9998C124.333 33.7832 98.216 7.6665 65.9993 7.6665C33.7827 7.6665 7.66602 33.7832 7.66602 65.9998C7.66602 98.2164 33.7827 124.333 65.9993 124.333Z",
    fill: "#00B96B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7164 86.8832C56.5497 86.8832 55.4414 86.4165 54.6247 85.5998L38.1164 69.0915C36.4247 67.3998 36.4247 64.5998 38.1164 62.9082C39.8081 61.2165 42.6081 61.2165 44.2997 62.9082L57.7164 76.3248L87.6997 46.3415C89.3914 44.6498 92.1914 44.6498 93.8831 46.3415C95.5748 48.0332 95.5748 50.8332 93.8831 52.5248L60.8081 85.5998C59.9914 86.4165 58.8831 86.8832 57.7164 86.8832Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665_13996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    rx: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.5aff7a13ad1601d33ebe6628728d6e49.svg";
export { ForwardRef as ReactComponent };